import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import useSeo, { buildBreadcrumb } from "../lib/useSeo";
import {
  Code2, Smartphone, Globe, Users, Network, BarChart3, Rocket, ArrowUpRight,
} from "lucide-react";

const ICONS = { Code2, Smartphone, Globe, Users, Network, BarChart3, Rocket };

export default function Servicios() {
  useSeo({
    title: "Servicios · Software a medida, Apps y MVPs · DoSoft Chile",
    description: "Servicios de DoSoft: software a medida, aplicaciones web y móviles, software factory, pilotos y MVPs, digitalización, business intelligence y asesoría en innovación.",
    canonical: "https://dosoft.cl/servicios",
    jsonLd: [
      buildBreadcrumb([
        { name: "Inicio", url: "/" },
        { name: "Servicios", url: "/servicios" },
      ]),
    ],
  });
  const [services, setServices] = useState([]);
  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="servicios-page">
      <section className="border-b border-ink-500 py-24 md:py-32 relative overflow-hidden">
        <div className="absolute inset-0 grid-lines opacity-20" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-xs uppercase tracking-widest text-brand font-mono mb-6">
            Servicios
          </div>
          <h1 className="font-display font-black text-5xl md:text-7xl tracking-tighter text-ash-100 max-w-4xl leading-[0.95]">
            Capacidades técnicas<br />de extremo a extremo.
          </h1>
          <p className="text-ash-300 mt-8 max-w-2xl text-lg leading-relaxed">
            Desde el primer prototipo hasta la operación 24/7. Equipos dedicados que
            piensan, diseñan, construyen y mantienen.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-px bg-ink-500 border border-ink-500">
            {services.map((s, i) => {
              const Icon = ICONS[s.icon] || Code2;
              return (
                <div
                  key={s.id}
                  data-testid={`servicio-${s.slug}`}
                  className="bg-ink-800 p-10 md:p-14 group hover:bg-ink-700 transition-colors"
                >
                  <div className="flex items-start justify-between mb-8">
                    <Icon size={36} strokeWidth={1.5} className="text-brand" />
                    <span className="text-xs font-mono text-ash-500">
                      {String(i + 1).padStart(2, "0")} / {String(services.length).padStart(2, "0")}
                    </span>
                  </div>
                  <h2 className="font-display font-bold text-3xl md:text-4xl tracking-tight text-ash-100 mb-3">
                    {s.title}
                  </h2>
                  <p className="text-brand text-sm uppercase tracking-widest font-mono mb-6">
                    {s.subtitle}
                  </p>
                  <p className="text-ash-300 leading-relaxed mb-8">{s.description}</p>
                  <ul className="space-y-3 mb-8">
                    {s.features.map((f, j) => (
                      <li key={j} className="flex items-start gap-3 text-ash-100">
                        <span className="text-brand font-mono text-xs mt-1">{String(j + 1).padStart(2, "0")}</span>
                        <span>{f}</span>
                      </li>
                    ))}
                  </ul>
                  <Link
                    to="/cotizador"
                    data-testid={`servicio-cta-${s.slug}`}
                    className="inline-flex items-center gap-3 text-sm uppercase tracking-widest text-ash-100 hover:text-brand transition-colors"
                  >
                    Cotizar este servicio
                    <ArrowUpRight size={16} strokeWidth={1.5} />
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
